/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_LanguageiconInputs */

const en_enum_custom_page_icon_languageicon = /** @type {(inputs: Enum_Custom_Page_Icon_LanguageiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_enum_custom_page_icon_languageicon = /** @type {(inputs: Enum_Custom_Page_Icon_LanguageiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Enum_Custom_Page_Icon_LanguageiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_languageicon = /** @type {((inputs?: Enum_Custom_Page_Icon_LanguageiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_LanguageiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_languageicon(inputs)
	return de_enum_custom_page_icon_languageicon(inputs)
});